<template>
	<div class="hit-row">
		<div class="hit-col-md-6 hit-col-md-hit-offset-3">

			<div class="hit-panel hit-panel-primary hit-html-html">
				<div class="hit-panel-heading">
					{{ $t('message.forgotPassword') }}
				</div>
				<div class="hit-panel-body">

					<div class="hit-col-md-12">
						<div class="hit-form-group">
							<div class="hit-input-group">
				        <div  class="hit-input-group-addon">
				          <i class="hit-glyphicon hit-glyphicon-user"></i>
				        </div>
								<input type="text" class="hit-form-control" v-bind:placeholder="$t('message.username')">
							</div>
						</div>
					</div>

					<div class="hit-col-md-12">
						<div class="hit-form-group">
							<div class="hit-input-group">
				        <div  class="hit-input-group-addon">
				          <i class="hit-glyphicon hit-glyphicon-envelope"></i>
				        </div>
								<input type="text" class="hit-form-control" v-bind:placeholder="$t('message.email')">
							</div>
						</div>
					</div>

					<div class="hit-col-md-12">
						<div class="hit-form-group">
							<button type="submit" class="hit-btn hit-btn-primary hit-btn-block">{{ $t('message.send') }}</button>
						</div>
					</div>

				</div>
				<div class="hit-panel-footer">
						<div class="hit-pull-right">
							<router-link class=" hit-html-a" :to="{ name: 'sign_in', params: {lang: $store.getters.lang} }">{{ $t('message.signIn') }}</router-link>
						</div>
						<router-link class=" hit-html-a" :to="{ name: 'sign_up', params: {lang: $store.getters.lang} }">{{ $t('message.signUp') }}</router-link>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
export default{
  name: 'forgot_password',
  data () {
    return {
      agb: false
    }
  },
  methods: {
    change_agb: function () { this.agb = !this.agb }
  }
}
</script>
